import businessSortItems from "assets/js/businessSortItems";

export function formatPrice(price?: number) {
  if (!price) return "0";
  try {
    const abs = Math.abs(price);
    const formated = abs.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumSignificantDigits: 12,
    });
    const pureNum = formated.replace("$", "");
    if (pureNum === "NaN") return "0";
    return pureNum ?? "0";
  } catch {
    return "0";
  }
}

export function formatIndex(index: number, digits: number) {
  try {
    const output = index + 1;
    let outputString = `${output}`;
    if (index >= 999) return outputString;
    for (let i = 1; i <= digits; i++) {
      if (Math.pow(10, i) > output) outputString = "0" + outputString;
    }
    return `${outputString}`;
  } catch {
    return "0";
  }
}

export function shortenString(text: string, count: number) {
  try {
    if (text.length <= count) return text;
    const sliced = text.slice(0, count);
    return `${sliced}...`;
  } catch {
    return `${text}...`;
  }
}
export const MiladiToJalali = (g_y: number, g_m: number, g_d: number, isString?: boolean): [number, number, number] | string => {
  let doy_j = 0
  let doy_g = 0
  let d_4 = 0
  let g_a: number | number[] = 0
  let d_33 = 0
  let a = 0
  let b = 0
  let jy = 0
  let jm = 0
  let jd = 0
  d_4 = g_y % 4
  g_a = [0, 0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334]
  doy_g = g_a[g_m] + g_d
  if (d_4 === 0 && g_m > 2) { doy_g++ }
  d_33 = Math.floor(((g_y - 16) % 132) * .0305)
  a = (d_33 === 3 || d_33 < (d_4 - 1) || d_4 === 0) ? 286 : 287
  b = ((d_33 === 1 || d_33 === 2) && (d_33 === d_4 || d_4 === 1)) ? 78 : ((d_33 === 3 && d_4 === 0) ? 80 : 79)
  if (Math.floor((g_y - 10) / 63) === 30) { a--; b++ }
  if (doy_g > b) {
    jy = g_y - 621; doy_j = doy_g - b
  } else {
    jy = g_y - 622; doy_j = doy_g + a
  }
  if (doy_j < 187) {
    jm = Math.floor((doy_j - 1) / 31); jd = doy_j - (31 * jm++)
  } else {
    jm = Math.floor((doy_j - 187) / 30); jd = doy_j - 186 - (jm * 30); jm += 7
  }
  if (isString) {
    return `${jy}/${jm < 10 ? '0' + jm : jm}/${jd < 10 ? '0' + jd : jd}`
  }
  return [jy, jm, jd]
}
export function toLineChartDataFormat(data: buyAndSaleDataType) {
  try {
    const output = [];
    for (const key in data) {
      output.push({
        // @ts-ignore
        title: data[key].name,
        // @ts-ignore
        value: data[key].totalPrice,
      });
    }
    return output;
  } catch {
    return [];
  }
}

export const mathPositive = (value: number) => {
  return Math.abs(value);
};

export function toIncomesCostsDataFormat(incomes: buyAndSaleDataType, costs: buyAndSaleDataType) {
  const output = [];
  for (const key in incomes) {
    output.push({
      title: (incomes as any)[key]?.name || "",
      income: mathPositive((incomes as any)[key]?.totalPrice) || 0,
      cost: mathPositive((costs as any)[key]?.totalPrice) || 0,
    });
  }
  return output;
  // return [
  //   {
  //     title: "خرداد",
  //     income: 1000,
  //     cost: -200,
  //   },
  //   {
  //     title: "تیر",
  //     income: 50,
  //     cost: -25,
  //   },
  //   {
  //     title: "مرداد",
  //     income: 150,
  //     cost: -230,
  //   },
  //   {
  //     title: "شهریور",
  //     income: 60,
  //     cost: -10,
  //   },
  //   {
  //     title: "مهر",
  //     income: 40,
  //     cost: -110,
  //   },
  //   {
  //     title: "آبان",
  //     income: 100,
  //     cost: 0,
  //   },
  //   {
  //     title: "آذر",
  //     income: 0,
  //     cost: -20,
  //   },
  //   {
  //     title: "دی",
  //     income: 150,
  //     cost: -120,
  //   },
  //   {
  //     title: "بهمن",
  //     income: 28,
  //     cost: -40,
  //   },
  //   {
  //     title: "اسفند",
  //     income: 40,
  //     cost: -30,
  //   },
  //   {
  //     title: "فروردین",
  //     income: 11,
  //     cost: -25,
  //   },
  //   {
  //     title: "اردیبهشت",
  //     income: 0,
  //     cost: -10,
  //   },
  // ];
}

export const convertToFormdata = (form: any) => {
  const formData = new FormData();

  for (var key in form) {
    form[key] && formData.append(key, form[key]);
  }

  return formData;
};

// export const convertToBusinessUpdateFormat = (form: any) => {
//     const main = new FormData();
//     const others = new FormData();
//     const output = new FormData();
//     for (var key in form) {
//         if (businessSortItems.main.find(item => item === key)) {
//             formData.append(key, form[key]);
//         }
//         if (businessSortItems.others.find(item => item === key)) {
//             // @ts-ignore
//             output.others[key] = form[key]
//         }

//     }

//     return output

// }

export const convertToBusinessUpdateFormat = (form: any) => {
  const output = { main: {}, others: [] };
  // @ts-ignore
  output.main.currencyId = form.default_currency_id;
  // @ts-ignore
  output.main.isGregorian = !!form.is_gregorian;
  for (var key in form) {
    if (businessSortItems.main.find((item) => item === key) && !!form[key]) {
      // @ts-ignore
      output.main[key] = form[key];
    }
    if (businessSortItems.others.find((item) => item === key)) {
      if (!!form[key] && form[key].length) {
        // @ts-ignore
        let setting = {};
        // @ts-ignore
        setting[key] = form[key];
        // @ts-ignore
        output.others.push(setting);
      }
    }
  }

  return output;
};

export const permissionSortByKeys = (data: permission[]) => {
  try {
    const parentTitles = [] as string[];

    const output = [] as {
      title: string;
      children: permission[];
    }[];

    data.forEach((item) => {
      if (parentTitles.findIndex((i) => i === item.parent_title) !== -1) return;

      output.push({
        title: item.parent_title,
        children: data.filter((it) => it.parent_title === item.parent_title),
      });
      return parentTitles.push(item.parent_title);
    });

    return output;
  } catch {
    return [];
  }
};

export const getAllowedPermissions = (
  permissions: {
    title: string;
    childs: permission[];
  }[]
) => {
  try {
    const permissionsArray = [] as permission[];

    permissions.map((permission) => {
      permission.childs.map((item) => {
        permissionsArray.push(item);
      });
    });

    return permissionsArray.filter((item) => item.status);
  } catch {
    return [];
  }
};
export const JalaliToMiladi = (jy: number, jm: number, jd: number) => {
  let gm
  let gy = (jy <= 979) ? 621 : 1600
  jy -= (jy <= 979) ? 0 : 979
  let days = (365 * jy) + ((Math.floor(jy / 33)) * 8) + (Math.floor(((jy % 33) + 3) / 4))
    + 78 + jd + ((jm < 7) ? (jm - 1) * 31 : ((jm - 7) * 30) + 186)
  gy += 400 * (Math.floor(days / 146097))
  days %= 146097
  if (days > 36524) {
    gy += 100 * (Math.floor(--days / 36524))
    days %= 36524
    if (days >= 365) days++
  }
  gy += 4 * (Math.floor((days) / 1461))
  days %= 1461
  gy += Math.floor((days - 1) / 365)
  if (days > 365) days = (days - 1) % 365
  let gd = days + 1
  const sal_a = [0, 31, ((gy % 4 === 0 && gy % 100 !== 0) || (gy % 400 === 0)) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
  for (gm = 0; gm < 13; gm++) {
    const v = sal_a[gm]
    if (gd <= v) break
    gd -= v
  }
  return [gy, gm, gd]
}